export default {
      id: "common__show-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__show",
      toString: function () {
        return this.url;
      }
    }